import { Component, inject, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import {
  DxLookupComponent,
  DxFileUploaderComponent,
  DxLoadPanelComponent,
  DxButtonComponent,
  DxValidatorComponent,
} from 'devextreme-angular';
import notify from 'devextreme/ui/notify';
import { GestArticoliBaseComponent } from 'src/app/shared/components/gest-articoli-base/gest-articoli-base.component';
import { DistributoriService } from 'src/app/shared/services/distributori.service';
import { ImportResult } from 'src/app/models/import-result';
import { PopupImportDistributoriResultComponent } from 'src/app/shared/components/popups/popup-errori-import-distributori/popup-import-distributori-result.component';
import { DxiValidationRuleComponent } from 'devextreme-angular/ui/nested';

@Component({
  selector: 'app-importa-dati-distributore',
  templateUrl: './importa-dati-distributore.component.html',
  styleUrls: ['./importa-dati-distributore.component.scss'],
  imports: [
    DxLookupComponent,
    DxFileUploaderComponent,
    PopupImportDistributoriResultComponent,
    DxLoadPanelComponent,
    DxButtonComponent,
    DxValidatorComponent,
    DxiValidationRuleComponent,
  ],
})
export class ImportaDatiDistributoreComponent
  extends GestArticoliBaseComponent
  implements OnInit
{
  private distrService = inject(DistributoriService);

  listDistributori: any;
  idDistributoreSelected: number;
  visibleLoadPanel = false;

  popupResultVisibleObs = new BehaviorSubject<boolean>(undefined);
  resultTitle = '';
  importResult: ImportResult = undefined;
  fileValue: any[] = [];

  ngOnInit() {
    this.loadLookups();
  }

  loadLookups() {
    this.distrService.listTemp().subscribe({
      next: (res) => {
        this.listDistributori = {
          store: {
            type: 'array',
            data: res,
            key: 'id',
          },
          pageSize: 10,
          paginate: true,
        };
      }
    });
  }

  allegaFile(files) {
    this.visibleLoadPanel = true;
    const formData = new FormData();
    formData.append('file', files[0]);
    this.distrService
      .importDatiDistributore(this.idDistributoreSelected, formData)
      .subscribe({
        next: (res) => {
          this.visibleLoadPanel = false;
          this.importResult = res;
          if (res.result) {
            notify('Il file è stato importato correttamente', 'success');
            this.resultTitle = 'Dati importati';
          } else {
            notify('Il file non è stato importato correttamente', 'warning');
            this.resultTitle = 'Dati non importati';
          }
          this.popupResultVisibleObs.next(true);
          this.clearForm();
        },
        error: (error) => {
          this.visibleLoadPanel = false;
          if (error?.status == 500 && error?.error?.title) {
            notify(error?.error?.title, 'warning');
          } else {
            notify('Errore importazione dati distributore', 'warning');
          }
        },
      });
  }

  clearForm() {
    this.idDistributoreSelected = null;
    this.fileValue = [];
  }

  getDisplayExprDistributore(item) {
    if (item) {
      return item.codice + ' - ' + item.descrizione;
    }
    return '';
  }
}
